import { render, staticRenderFns } from "./AttendKpSzList.vue?vue&type=template&id=08c3217c&scoped=true&"
import script from "./AttendKpSzList.vue?vue&type=script&lang=js&"
export * from "./AttendKpSzList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3217c",
  null
  
)

export default component.exports